/** @jsxRuntime automatic */
import ReactDOM from 'react-dom/client';
import 'leaflet/dist/leaflet.css';

import { DesktopDashboard } from './DesktopDashboard';
import { buildDashboardData, dashboardCopy, mapProviderConfig } from '../shared';

const rootEl = document.getElementById('root');
const dashboardData = buildDashboardData();

if (rootEl) {
  const root = ReactDOM.createRoot(rootEl);
  root.render(
    <DesktopDashboard
      data={dashboardData}
      copy={dashboardCopy}
      mapConfig={mapProviderConfig}
    />
  );
}
